import * as React from 'react';

const SvgAlertCircle = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    width={24}
    height={24}
    viewBox="0 0 24 24"
    fill="none"
    stroke="#8e4545"
    strokeLinecap="round"
    strokeLinejoin="round"
    className="alert-circle_svg__feather alert-circle_svg__feather-alert-circle"
    {...props}
  >
    <circle cx={12} cy={12} r={10} />
    <path d="M12 8v4M12 16h0" />
  </svg>
);

export default SvgAlertCircle;
